<template>
  <div class="md:flex md:flex-shrink-0 print:hidden">
    <div
      v-if="$page.props.settings.sidebar == 'mini'"
      class="bg-gray-900 md:flex-shrink-0 md:w-16 px-6 py-3 flex items-center justify-between md:justify-center"
    >
      <Link class="text-gray-100" :href="route('dashboard')">
        <tec-application-mark class="block h-8" />
      </Link>
      <mobile-menu-icon @on-change="v => (show = v)" />
    </div>
    <div v-else class="bg-gray-900 md:flex-shrink-0 md:w-56 px-6 py-3 flex items-center justify-between md:justify-center">
      <Link class="text-gray-100" :href="route('dashboard')">
        <tec-application-logo class="block w-48" />
      </Link>
      <mobile-menu-icon @on-change="v => (show = v)" />
    </div>
    <div class="bg-white border-b w-full py-2 px-4 md:py-0 text-sm md:text-md flex justify-between items-center">
      <!-- <div class="mt-1 mr-4">{{ $page.props.user.name.account.name }}</div> -->
      <div class="mt-1 mr-4">
        <tec-dropdown align="left" width="48" v-if="$can(['create-customers', 'create-users', 'create-roles'])">
          <template #trigger>
            <button
              class="flex items-center text-sm p-1 border-2 border-transparent rounded-md focus:outline-none focus:border-gray-300 transition duration-150 ease-in-out"
            >
              <icons name="plus" class="-ml-1 mr-1"></icons>
              New
            </button>
          </template>

          <template #content>
            <tec-dropdown-link v-if="$can('create-sales')" :href="route('sales.create')">
              {{ $t('Create New Sale') }}
            </tec-dropdown-link>
            <tec-dropdown-link v-if="$can('create-customers')" :href="route('customers.create')">
              {{ $t('Create New Customer') }}
            </tec-dropdown-link>
            <!-- <tec-dropdown-link v-if="$can('create-tax-rates')" :href="route('tax_rates.create')">
              {{ $t('Create Tax Rate') }}
            </tec-dropdown-link> -->
            <tec-dropdown-link v-if="$can('create-users')" :href="route('users.create')"> {{ $t('Create New User') }} </tec-dropdown-link>
            <tec-dropdown-link v-if="$can('create-roles')" :href="route('roles.create')"> {{ $t('Create New Role') }} </tec-dropdown-link>
          </template>
        </tec-dropdown>
      </div>

      <div class="flex items-center gap-x-3">
        <icon-menus class="hidden sm:flex gap-x-3 items-center" />

        <tec-dropdown align="right" width="48">
          <template #trigger>
            <button
              class="flex items-center text-sm border-2 border-transparent rounded-full focus:outline-none focus:border-gray-300 transition duration-150 ease-in-out"
            >
              <img
                :alt="$page.props.user.name"
                :src="$page.props.user.profile_photo_url"
                class="h-8 w-8 rounded-full object-cover sm:mr-2"
                v-if="$page.props.jetstream.managesProfilePhotos"
              />
              <span class="hidden sm:inline-flex items-center mr-2">
                {{ $page.props.user.name }}
                <icons name="chevron-down" class="ml-2 -mr-1" />
              </span>
            </button>
          </template>

          <template #content>
            <div class="block px-4 py-2 text-xs text-gray-400">Manage Account</div>
            <tec-dropdown-link :href="route('profile.show')"> Profile </tec-dropdown-link>
            <tec-dropdown-link :href="route('api-tokens.index')" v-if="$page.props.jetstream.hasApiFeatures">
              API Tokens
            </tec-dropdown-link>

            <div class="border-t border-gray-100"></div>
            <form @submit.prevent="logout">
              <tec-dropdown-link as="button"> Log Out </tec-dropdown-link>
            </form>
          </template>
        </tec-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

import Icons from '@/Shared/Icons';
import IconMenus from './IconMenus';
import TecDropdown from '@/Jetstream/Dropdown';
import TecDropdownLink from '@/Jetstream/DropdownLink';
import MobileMenuIcon from '@/Shared/Top/MobileMenuIcon';
import TecApplicationLogo from '@/Jetstream/ApplicationLogo';
import TecApplicationMark from '@/Jetstream/ApplicationMark';

export default {
  emits: ['on-mobile-menu-change'],
  components: {
    Link,
    Icons,
    IconMenus,
    TecDropdown,
    MobileMenuIcon,
    MobileMenuIcon,
    TecDropdownLink,
    TecApplicationLogo,
    TecApplicationMark,
  },
  data() {
    return { show: false };
  },
  watch: {
    show(show) {
      this.$emit('on-mobile-menu-change', show);
    },
  },
  methods: {
    logout() {
      this.$inertia.post(route('logout'));
    },
  },
};
</script>
